module.exports = __webpack_public_path__ + "static/media/9_l_katushka2_15.52_88.8.f2f2d017.png";